import { Component, input } from '@angular/core';
import { InspectionStatus } from '@app/core/enums/inspection-status.enum';
import { Inspection } from '@app/core/models/inspection.model';
import _ from 'lodash';

export type RowClickHandler = (row, $event) => void;
export type StateHandler = (row) => boolean;
export type VisibilityHandler = (row) => boolean;
export interface InspectionTable {
    rowClickEvent: RowClickHandler,
    columnMappings: {
        name: string;
        prop: string;
    }[],
    rowData: any[],
    actions: {
        icon: string;
        tooltip?: string,
        handler: RowClickHandler,
        enableStateHandler: StateHandler,
        visibilityHandler?: VisibilityHandler
    }[],
    isSearchResult: boolean
}

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: 'inspekt-table',
    templateUrl: './inspekt-table.component.html',
    styleUrls: ['./inspekt-table.component.scss'],
    imports: [NgxDatatableModule, MatButtonModule, MatIconModule, MatTooltipModule]
})
export class InspektTableComponent {

    readonly data = input<InspectionTable>();
    public JSON: any;

    constructor() {
        this.JSON = JSON;
    }

    public preventDefaultRowClickBehavior($event) {
        $event.stopPropagation();
    }

    public getRowClass(row: Inspection) {
        return {
            'creating-inspection': (() => {
                return row.status === InspectionStatus.Creating
            })(),
            'error-inspection': (() => {
                return row.status === InspectionStatus.Error
            })()
        };
    }

    public getValueByPath(obj, path) {
        return _.get(obj, path, '');
    }
}
